export const formatBRL = (
  value,
  { fallback = '', fractionDigits = 0 } = {}
) => {
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num)) return fallback;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
    .format(num)
    .replace(/ /g, ' ');
};
